import _ from 'lodash'
import moment from 'moment'

export class GanttChartData {
  public constructor (
    readonly name: string,
    readonly fromDate: string,
    readonly toDate: string,
    readonly label: string,
    readonly color: string,
    readonly type: string
  ) {}

  static createListFromResponse (data: any): Array<GanttChartData> {
    let ganttChartData: Array<GanttChartData> = []

    _.each(data, (val, key) => {
      if (key === 'shift') {
        val.forEach((item: any) => {
          ganttChartData.push(new GanttChartData(
            item.employee_name,
            moment(item.date_from).format('YYYY-MM-DD HH:mm'),
            moment(item.date_to).format('YYYY-MM-DD HH:mm'),
            item.label,
            item.color,
            key)
          )
        })
      } else if (key === 'absences') {
        val.forEach((item: any) => {
          ganttChartData.push(new GanttChartData(
            item.employee_name,
            moment(item.date_from).format('YYYY-MM-DD HH:mm'),
            moment(item.date_to).format('YYYY-MM-DD HH:mm'),
            item.label,
            item.color,
            key)
          )
        })
      } else if (key === 'calendar') {
        val.forEach((item: any) => {
          ganttChartData.push(new GanttChartData(
            item.employee_name,
            moment(item.date_from).format('YYYY-MM-DD HH:mm'),
            moment(item.date_to).format('YYYY-MM-DD HH:mm'),
            item.label,
            item.color,
            key)
          )
        })
      }
    })
    return ganttChartData
  }
}
